import React, { FC } from 'react'
import { AchievementsHook } from '../../hooks/useAchievements'
import { useProgressBarAnimation } from '../../hooks/useProgressBarAnimation'

interface AchievementProgressBarProps {
	lastObservedStep: number
	setLastObservedStep: AchievementsHook['setLastObservedStep']
	currentStep: number
	goal: number
	achievementId: number
}

const AchievementProgressBar: FC<AchievementProgressBarProps> = ({
	lastObservedStep,
	setLastObservedStep,
	currentStep,
	goal,
	achievementId,
}) => {
	const progressRef = useProgressBarAnimation({
		lastObservedStep,
		setLastObservedStep,
		currentStep,
		goal,
		achievementId,
	})

	return (
		<div className='w-full h-2 mt-2 mb-1 bg-[#e5e5e5] dark:bg-text-grey-100 rounded-full'>
			<div
				ref={progressRef}
				className='h-full bg-gradient-to-l from-brand-secondary-100-light to-brand-primary-100-light dark:from-brand-primary-100-dark dark:to-brand-secondary-100-dark rounded-full'
			/>
		</div>
	)
}

export default AchievementProgressBar
